import type { SdkResourceField } from './types';

/**
 * Orders auto-derived (default) field lists by the resource's configured field order
 * (`settings.sort_order`): nulls last, ascending, with the catalog's incoming order as
 * the stable tiebreaker. Mirrors the admin `FieldsTable` sort so the SDK's table, forms,
 * and record views all surface fields in the order users arrange them.
 *
 * Only apply this to the default field set — explicit author-provided `columns`/`fields`
 * keep their given order untouched.
 */
export function compareFieldSortOrder(a: SdkResourceField, b: SdkResourceField): number {
  const aOrder = a.settings?.sort_order;
  const bOrder = b.settings?.sort_order;
  if (aOrder == null && bOrder == null) {
    return 0;
  }
  if (aOrder == null) {
    return 1;
  }
  if (bOrder == null) {
    return -1;
  }
  return aOrder - bOrder;
}
